module.exports = __webpack_public_path__ + "imgs/Norml.e2a1834148c65b603e909b00ce68c882.png";